import { render, staticRenderFns } from "./AssessmentHistory.vue?vue&type=template&id=4a529b74&"
import script from "./AssessmentHistory.vue?vue&type=script&lang=js&"
export * from "./AssessmentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports